/** Fallback when API parcel_lot_map is not loaded yet (mirrors config/constants.php parcel_lot_mm). */
export const PARCEL_LOT_MM = {
  '-2': ['0.60', '0.70', '0.80', '0.90', '1.00', '1.10', '1.20'],
  '-6.5': ['1.25', '1.30', '1.40', '1.50', '1.60', '1.70'],
  '+6.5,-8': ['1.80', '1.90', '2.00'],
  '+6.5,+8,-9': ['2.10', '2.20', '2.25'],
  '+6.5,+9,-11': ['2.30', '2.40', '2.50', '2.60'],
  '+11,-12': ['2.70', '2.80', '2.90'],
  '+12,-14': ['2.90', '3.00', '3.10', '3.20', '3.30'],
  '+14': ['3.30', '3.40', '3.50'],
};

export const formatMmOptionValue = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value ?? '').trim();
  return n.toFixed(2);
};

export const normalizeMmValues = (values) => {
  if (!Array.isArray(values)) return [];
  return values
    .map((v) => formatMmOptionValue(v))
    .filter((v) => v !== '');
};

/** Normalize parcel lot key for select value / map lookup (API may return number -2). */
export const normalizeParcelKey = (value) => {
  if (value === null || value === undefined) return "";
  const s = String(value).trim();
  if (s === "" || s === "null" || s === "undefined") return "";
  return s;
};

/** Parse product `mm` from API (array or JSON string). */
export const parseProductMmValues = (mm) => {
  if (Array.isArray(mm)) return normalizeMmValues(mm);
  if (typeof mm === "string" && mm.trim() !== "") {
    try {
      const parsed = JSON.parse(mm);
      if (Array.isArray(parsed)) return normalizeMmValues(parsed);
    } catch (e) {
      return normalizeMmValues(mm.split(","));
    }
  }
  return [];
};

export const getParcelLotMmValues = (parcelKey, map) => {
  const key = normalizeParcelKey(parcelKey);
  if (!key || !map || typeof map !== "object") return null;
  if (Array.isArray(map[key])) return normalizeMmValues(map[key]);
  return null;
};
